import { API_REQUEST, FAILURE } from './api-middleware';
import { forceRelogin } from 'actions/user';
import _ from 'lodash';

export default store => next => action => {
  if (!action) {
    return;
  }

  if (!isFailedRequest(action.meta)) {
    return next(action);
  }

  if (isUnauthorizedError(action.payload)) {
    const state = store.getState();
    // Don't do anything when another relogin has been triggered before
    if (state.app.user.relogin) {
      return;
    }

    next(forceRelogin());
  }

  return next(action);
};

function isUnauthorizedError(error) {
  return _.get(error, 'response.status') === 401;
}

function isFailedRequest(meta) {
  if (meta && meta[API_REQUEST] && meta.requestStatus === FAILURE) {
    return true;
  }

  return false;
}
